import React, { useEffect, useState } from 'react';
import * as api from 'js/social/api';
import { ResourceType, UserLike } from 'js/social/shared/types';
import { UserListMenu } from './UserListMenu';

type Props = {
  resourceId: number | string;
  resourceType: ResourceType;
};

export const LikesMenu: React.FC<React.PropsWithChildren<Props>> = ({
  resourceId,
  resourceType,
  children,
}) => {
  const [users, setUsers] = useState<UserLike[]>([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!visible || users.length > 0) return;

    setLoading(true);
    api
      .getReactions(resourceId, resourceType)
      .then((reactions) => reactions.like)
      .then(setUsers)
      .finally(() => setLoading(false));
  }, [resourceId, resourceType, users.length, visible]);

  return (
    <UserListMenu
      users={users}
      loading={loading}
      menuProps={{ onChange: setVisible }}
    >
      {children}
    </UserListMenu>
  );
};
